import React, { useEffect, useState } from 'react';
import AxiosClient from '../../assets/AxiosClient';
import { useNavigate, useParams } from 'react-router-dom';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import AcceptRequest from '../../Models/AcceptRequest.jsx';
import Loader from '../../assets/tools/Loder/loader';


const Request = () => {
  const [showAccept , setShowAccept] = useState(false) ; 
  const {API} = useStateContext();
    const {SetNotification} =useStateContext () ;
  const [user, setUser] = useState(null);
  const [loading, setIsLoading] = useState(true);  
  const [status , setStatus] = useState(null) ; 
  const [code , setCode] =useState (null) ; 
  const [imageError, setImageError] = useState(false);

  const { id } = useParams();
  const [l_id , setL_id] = useState(0); 
const navigate = useNavigate() ; 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get(`/Registeration/show/${id}`);
        if (response.status === 200) {
          setUser(response.data.user);
          setL_id(response.data.lastAttend.id) ; 
          setCode(response.data.invitation); 
          console.log (response) ; 
          setIsLoading(false);
          setStatus(response.data.lastAttend.status);
        }
      } catch (error) {
        SetNotification("Error fetching data from Server" , "danger");

      }
    };

    fetchData();

  }, [id , showAccept ]);

 
  const handelDecline = async()=>{
    const confirmed = window.confirm("Are you sure you want to Decline this  Request?");
    if (!confirmed) return ;
    await AxiosClient.post(`/Registeration/Declined/${l_id}`).then((response)=>{
      if (response.status ==200){
        SetNotification("Request has been Declined" , "warning");
        navigate("/Requests"); 
      }
    }); 
   
  }
  const handelDelete  = async()=>{
    const confirmed = window.confirm("Are you sure you want to Delete  this  Request?");
    if (!confirmed) return ;
    await AxiosClient.delete(`/attendances/${l_id}`).then((response)=>{
      if (response.status ==200){
        SetNotification("Request has been Deleted" , "warning");
        navigate("/Requests"); 
      }
    }); 
   
  }

  const handelCancel = async()=>{
   
      navigate("/Requests"); 
    
  }

  const getImageUrl = (imagePath) => {
    if (!imagePath) {
      return '';
    }

    if (/^https?:\/\//i.test(imagePath)) {
      return imagePath;
    }

    if (imagePath.startsWith('/')) {
      return `${API}${imagePath}`;
    }

    return `${API}/${imagePath}`;
  };

  const initials = user ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase() : 'U';
  const profileImage = getImageUrl(user?.image);
  const fallbackImage = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><rect width='100%' height='100%' fill='#e2e8f0'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-size='64' fill='#64748b' font-family='Arial'>${initials}</text></svg>`)}`;

  return (
    <>
      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="card-header border-0 px-4 py-4" style={{ background: 'linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%)' }}>
          <div className="d-flex flex-column flex-lg-row justify-content-between gap-2">
            <div>
              <h4 className="card-title mb-1">Request attending</h4>
              <p className="text-muted mb-0">Review the request details and decide on the next step.</p>
            </div>
            {!loading && code && (
              <div className="align-self-start">
                <span className="badge rounded-pill bg-white text-dark border px-3 py-2 shadow-sm">
                  {code.title} • {code.invitation_code}
                </span>
              </div>
            )}
          </div>
        </div>

        {loading ? (
          <Loader label="Loading request details..." />
        ) : (
          <div className="card-body p-4">
            <div className="row g-4 align-items-start">
              <div className="col-lg-8">
                <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                  <span className="badge rounded-pill bg-success-subtle text-success">{status === 'accepted' ? 'Accepted' : 'Pending review'}</span>
                  <span className="badge rounded-pill bg-light text-dark">{user.role || 'Guest'}</span>
                </div>

                <div className="row g-3">
                  <div className="col-md-6">
                    <p className="mb-2"><span className="fw-semibold text-dark">Name:</span> {user.first_name} {user.last_name}</p>
                    <p className="mb-2"><span className="fw-semibold text-dark">Email:</span> {user.email}</p>
                    <p className="mb-2"><span className="fw-semibold text-dark">Position:</span> {user.position || '—'}</p>
                    <p className="mb-2"><span className="fw-semibold text-dark">Gender:</span> {user.gender || '—'}</p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-2"><span className="fw-semibold text-dark">Address:</span> {user.country || '—'} {user.city || ''}</p>
                    <p className="mb-2"><span className="fw-semibold text-dark">Organization:</span> {user.organization || '—'}</p>
                    <p className="mb-2"><span className="fw-semibold text-dark">Nationality:</span> {user.nationality || '—'}</p>
                    <p className="mb-2"><span className="fw-semibold text-dark">Phone:</span> {user.phone || '—'}</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="rounded-4 border shadow-sm overflow-hidden bg-light p-2 mx-auto" style={{ maxWidth: 260 }}>
                  <img
                    src={imageError ? fallbackImage : profileImage || fallbackImage}
                    className="img-fluid rounded-3"
                    alt="Profile"
                    onError={() => setImageError(true)}
                    style={{ height: 240, objectFit: 'cover', width: '100%', display: 'block' }}
                  />
                </div>
              </div>
            </div>

            <div className="mt-4 p-3 rounded-4 border bg-light-subtle">
              {showAccept && <AcceptRequest user={user} attend={l_id} handelClose={() => setShowAccept(false)} />}
            </div>

            <div className="d-flex flex-wrap align-items-center gap-2 mt-4">
              {status !== 'accepted' ? (
                <>
                  <button className="btn btn-success" onClick={() => setShowAccept(true)}>
                    Accept
                  </button>
                  <button className="btn btn-warning" onClick={() => handelDecline(user.attendance_id)}>
                    Decline
                  </button>
                  <button className="btn btn-danger" onClick={() => handelDelete(user.attendance_id)}>
                    Delete
                  </button>
                </>
              ) : (
                <span className="text-success fw-semibold">This request has already been accepted.</span>
              )}

              <button className="btn btn-dark" onClick={handelCancel}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Request;